import { getAccessToken, getCsrfToken, clearAllTokens } from "../tokenStore";

const BASE_URL = process.env.REACT_APP_BASE_URL;

/**
 * Logout the current web session
 * Must include both Authorization and x-csrf-token headers
 * Clears all tokens regardless of API result
 */
export const logoutApi = async () => {
  try {
    const token = getAccessToken();
    const csrf  = getCsrfToken();

    await fetch(`${BASE_URL}/web-auth/logout`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
        ...(csrf  && { "x-csrf-token": csrf }),
      },
    });
  } catch {
    // Always clear tokens even if the API call fails
  } finally {
    clearAllTokens();
    localStorage.removeItem("authUser");
  }
};
